import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/(protected)/my-dogs/page.tsx");
